<template>
  <div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="apply-width-one" scope="col"></th>
          <th class="apply-width-two" scope="col">Año</th>
          <th class="apply-width" colspan="2" scope="col">Iniciativa</th>
          <th class="apply-width-four" scope="col">Estado de Avance</th>
        </tr>
      </thead>
      <tbody>
        <Row
          v-for="(item, index) in lista"
          :key="index"
          :objTest="item"
          :index="index"
          @handlerSelectedRow="handlerSelectedRow"
        />
      </tbody>
    </table>
  </div>
</template>

<script>
import Row from "./Row.vue";

import { mapState } from "vuex";


export default {
  props: ["lista", "MainHandlerSelectedRow"],
  components: {
    Row,

  },
  data() {
    return {
      selectedData: [],
    };
  },
  computed: {
    ...mapState("sesion", ["usuario"]),

    formattedList: function() {
      const toSend = this.itemList.map((i) => ({
        ...i,
        diferencia: this.difference(i),
      }));

      return toSend;
    },
  },
  methods: {
    handlerSelectedRow(index, data, value) {
      if (value === "accepted") this.selectedData[`index-${index}`] = data;
      else delete this.selectedData[`index-${index}`];
      this.$emit("MainHandlerSelectedRow", Object.values(this.selectedData));

    },



  },
};
</script>

<style scoped>
.row-button {
  display: flex;
  justify-content: space-between;
  margin: 25px 0;
}
.apply-width {
  width: 84%;
}

.apply-width-one {
  width: 1%;
}

.apply-width-two {
  width: 5%;
}

.apply-width-four {
  width: 10%;
}
.apply-fs {
  font-size: 0.9rem;
}

table {
  font-size: 1rem !important;
  margin: 0;
  border: 1px solid #f5f5f5 !important;
}
thead {
  background-color: #f5f5f5;
  color: #24c6ab;
  text-align: left !important;
}
tr:hover {
  background: none !important;
  text-align: left !important;
}
th {
  font-size: 1rem !important;
  text-align: left !important;
  width: 21%;
}
.table-resaltar {
  font-weight: bold;
  background: #f5f5f5;
}
.table-resaltar:hover {
  background: #f5f5f5 !important;
}
td {
  text-align: left !important;
  width: 21%;
}

.table-striped > tbody > tr:nth-child(even) > td,
.table-striped > tbody > tr:nth-child(even) > th {
  background-color: #f5f5f5;
}
.table-striped > thead > tr > th {
  background-color: #f5f5f5;
}
</style>
